module.exports = __webpack_public_path__ + "static/media/piano_annuale_cammino.257db520.jpg";